import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/src/view/styles/variables';
import { MatchingAssessmentDiagnosisAnswer, } from '@lean-body/src/domain';
import { DiagnosisChoiceButton, DiagnosisStepFooter } from '../molecules';
export const MatchingAssessmentDiagnosisStepForm = ({ step, currentAnswer, onComplete }) => {
    const [selectedChoices, setSelectedChoices] = useState([]);
    useEffect(() => {
        if (currentAnswer) {
            setSelectedChoices(step.choices.filter((c) => currentAnswer.choiceLabels.includes(c.label)));
        }
        else {
            setSelectedChoices([]);
        }
    }, [step.stepType]);
    const handleChoiceClick = (choice) => {
        if (step.isMultipleChoice) {
            const isSelected = selectedChoices.some((c) => c.label === choice.label);
            setSelectedChoices(isSelected ? selectedChoices.filter((c) => c.label !== choice.label) : [...selectedChoices, choice]);
        }
        else {
            setSelectedChoices([choice]);
        }
    };
    const handleNext = () => {
        onComplete(MatchingAssessmentDiagnosisAnswer.createParam(step, selectedChoices));
    };
    const isSelected = (choice) => {
        return selectedChoices.some((c) => c.label === choice.label);
    };
    const isDisabled = selectedChoices.length === 0;
    const isRatingStep = step.isMotivationStep && !step.isMultipleChoice && step.choices.length === 5;
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.title) }, step.title),
        isRatingStep ? (React.createElement("div", { className: css(styles.ratingContainer) },
            React.createElement("div", { className: css(styles.ratingButtons) }, step.choices.map((choice, index) => {
                return (React.createElement("div", { key: `${step.stepType}-${index}`, className: css(styles.ratingButton, isSelected(choice) && styles.ratingButtonSelected), onClick: () => handleChoiceClick(choice) }, choice.label));
            })),
            React.createElement("div", { className: css(styles.ratingLabels) },
                React.createElement("span", { className: css(styles.ratingLabel) }, "\u4F4E\u3044"),
                React.createElement("span", { className: css(styles.ratingLabel) }, "\u9AD8\u3044")))) : (React.createElement("div", { className: css(styles.choicesContainer) }, step.choices.map((choice, index) => (React.createElement(DiagnosisChoiceButton, { key: `${step.stepType}-${index}`, choice: choice, isSelected: isSelected(choice), onClick: () => handleChoiceClick(choice), isMultipleChoice: step.isMultipleChoice }))))),
        React.createElement(DiagnosisStepFooter, { isDisabled: isDisabled, onNext: handleNext, buttonText: "\u6B21\u3078" })));
};
const styles = StyleSheet.create({
    container: {
        paddingBottom: 120,
        [MediaBreakPointUp.MD]: {
            maxWidth: 327,
            margin: '0 auto',
            paddingTop: 90,
        },
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        color: Colors.TextDark,
        lineHeight: '140%',
        letterSpacing: 1.6,
        marginBottom: 40,
        textAlign: 'center',
    },
    choicesContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    ratingContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        alignItems: 'center',
    },
    ratingButtons: {
        display: 'flex',
        gap: 6,
    },
    ratingButton: {
        width: 60,
        height: 62,
        borderRadius: 14,
        border: `1px solid ${Colors.Gray}`,
        backgroundColor: Colors.White,
        fontSize: 14,
        fontWeight: 'bold',
        color: Colors.TextDark,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    ratingButtonSelected: {
        borderColor: Colors.PrimaryDark,
        backgroundColor: Colors.PrimaryLighter,
        borderWidth: 2,
    },
    ratingLabels: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    ratingLabel: {
        fontSize: 16,
        fontWeight: 500,
        color: Colors.GrayDarkest,
    },
});
